import React, { Suspense, useState } from "react";
import LoadingSpinner from "@/components/shared/LoadingSpinner";
import SellCarSEO from "@/components/sellcar/SellCarSEO";
import SellCarHero from "@/components/sellcar/SellCarHero";
import SellCarLayout from "@/components/sellcar/SellCarLayout";
import SellCarContent from "@/components/sellcar/SellCarContent";
import { Card, CardContent } from "@/components/ui/card";
import { CarValuationWidget } from "@/components/valuation/CarValuationWidget";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { RegistrationInputButton } from "@/components/valuation/RegistrationInputButton";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const SellCar = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const valuationTitle =
    labels.menuPages?.sellCar?.valuationTitle || "Få en kostnadsfri värdering";
  const [showValuation, setShowValuation] = useState(false);

  return (
    <div className="relative w-full min-h-screen bg-black">
      <SellCarSEO />

      <Suspense fallback={<LoadingSpinner />}>
        <SellCarHero />
      </Suspense>

      <SellCarLayout>
        {/* Car Valuation Section - Same as landing page */}
        <div
          id="car-valuation-section"
          className="max-w-2xl mx-auto mb-12 mt-24"
        >
          <h2 className="text-xl text-white md:text-3xl font-bold text-center mb-6">
            {valuationTitle || "Få en kostnadsfri värdering"}
          </h2>
          <RegistrationInputButton onClick={() => setShowValuation(true)} />
        </div>

        {/* Car Valuation Dialog */}
        <Dialog open={showValuation} onOpenChange={setShowValuation}>
          <DialogContent className="max-w-3xl max-h-[85%] overflow-y-auto">
            <CarValuationWidget
              onClose={() => setShowValuation(false)}
              showCloseButton={false}
            />
          </DialogContent>
        </Dialog>

        <SellCarContent onValuationClick={() => setShowValuation(true)} />
      </SellCarLayout>
    </div>
  );
};

export default SellCar;
